import React from 'react';
import Document from './Document';
import ComingSoon from './ComingSoon';

const DocumentList = ({ documents }) => {
  if (!documents || documents.length === 0) {
    return <ComingSoon />;
  }

  return (
    <div style={{ display: 'flex', gap: '5px', justifyContent: 'center' }}>
      {documents.map((document, index) => {
        const version = index + 1;
        return (
          <div key={document.id} style={{ textAlign: 'center' }}>
            {!document?.tableTooltip && (
              <p style={{ fontSize: '0.8rem', marginBottom: '5px', color: 'black' }}>
                <strong>V{version}</strong>
              </p>
            )}
            <Document document={document} />
          </div>
        );
      })}
    </div>
  );
};

export default DocumentList;
